module.exports = __webpack_public_path__ + "img/undurraga.fd9ec8cd.png";